import React, { SetStateAction } from 'react';
import moment from 'moment';
import { AnyIfEmpty } from 'react-redux';
import { hasPermission } from '../../auth/login/Login';
import iconClose from '../../../images/icon-close.svg';
import DeleteIcon from '../../svgIcons/DeleteIcon';
import styles from '../AppointmentFullCalendar/AppointmentFullCalendar.module.css';
interface props {
    calendarInfo: AnyIfEmpty<object>;
    setOpen: (active: boolean) => void;
    locationId: string;
    setShowDeletePopup: React.Dispatch<SetStateAction<boolean>>;
}

const AvailabilityPopup = ({ calendarInfo, setOpen, locationId, setShowDeletePopup }: props) => {
    const canDeleteAvailability = hasPermission('Self-Guided Tours', 'Availability', 'delete');

    const closeModal = () => {
        setOpen(false);
    }
    return (
        <div className={`${styles.eventInfo} ${styles.availability}`}>
            <div className={styles.eventHeader}>
                <div className={styles.titleWrap}>
                    <h2>Availability</h2>
                    {canDeleteAvailability && (
                        <img src={iconClose}
                            onClick={closeModal}
                            alt="Close"
                            className={styles.iconRemove} />
                    )}
                </div>
            </div>
            <div className={styles.eventBody}>
                <div className={styles.eventData}>
                    <label className={styles.eventTitle}>Unit</label>
                    <div className={styles.eventDescWrapper}>
                        <p className={styles.eventDesc}>
                            {calendarInfo.extendedProps?.unitYardiId
                                ? calendarInfo.extendedProps?.unitYardiId
                                : calendarInfo.extendedProps.unit_number}
                        </p>
                    </div>
                </div>
                <div className={styles.eventData}>
                    <label className={styles.eventTitle}>Locker number</label>
                    <p className={styles.eventDesc}>{calendarInfo.extendedProps.locker_number}</p>
                </div>
                <div className={styles.eventData}>
                    <label className={styles.eventTitle}>Start Date</label>
                    <p className={styles.eventDesc}>{moment(calendarInfo.extendedProps.start_date).locale('en').format('MM-DD-YYYY')}</p>
                </div>
                <div className={styles.eventData}>
                    <label className={styles.eventTitle}>End Date</label>
                    <p className={styles.eventDesc}>{moment(calendarInfo.extendedProps.end_date).locale('en').format('MM-DD-YYYY')}</p>
                </div>
                <div className={styles.eventData}>
                    <label className={styles.eventTitle}>Opening time</label>
                    <p className={styles.eventDesc}>{moment(calendarInfo.extendedProps.opening_time, 'hh:mm A').format('h:mm A')}</p>
                </div>
                <div className={styles.eventData}>
                    <label className={styles.eventTitle}>Closing time</label>
                    <p className={styles.eventDesc}>
                        {(() => {
                            // Convert 00:00 to 23:59 to ensure consistent display with calendar
                            const normalizedClosingTime = calendarInfo.extendedProps.closing_time === '00:00' ? '23:59' : calendarInfo.extendedProps.closing_time;
                            return moment(normalizedClosingTime, 'HH:mm').format('h:mm A');
                        })()}
                    </p>
                </div>
            </div>
            <div className={styles.centered}>

                {canDeleteAvailability && (
                    <div>
                        <button onClick={() => {
                            setShowDeletePopup(true);
                            setOpen(false);
                        }} className={`${styles.Modalbtn1} ${styles.deleteBtn1}`}>
                            <DeleteIcon stroke='#fff' width={18} height={18} />
                            Delete
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AvailabilityPopup;
